import React from 'react'
import { injectIntl } from 'react-intl';
import { FormattedMessage } from 'react-intl';
import withStyles from "isomorphic-style-loader/withStyles";
import cx from "classnames";
import messages from '../../locale/messages';
import { getStatusText } from '../../helpers/statusText';
import history from '../../history';
import bt from '../../components/commonStyle.css';
import s from './BookingIdCard.css';


function BookingIdCard({ id, isBookingPage, status, isTrackPage, isTopRadius }) {

    const { text: bookingStatusText, color: bookingStatusColor } = getStatusText({ status });

    return (
        <div className={cx(bt.commonViewBookingRsBox, isTopRadius ? s.bookingIdBoxTopRadius : bt.bookingIdBoxBottomRadius)}>
            <div className={s.bookingIdCardWrapper}>
                <div className={s.bookingIdInfoIdBox}>
                    <span className={bt.displayInlineBlock}><FormattedMessage {...messages.idText} /></span>
                    <span className={bt.displayInlineBlock}>&nbsp;#{id}</span>
                </div>
                {isBookingPage ? (
                    <a href={`/booking/${id}`}
                        onClick={(e) => {
                            e.preventDefault();
                            history.push({ pathname: `/booking/${id}`, state: { from: history.location.pathname } });
                        }}
                        className={bt.viewAllLink}
                    >
                        <FormattedMessage {...messages.bookingDetails} />
                    </a>
                ) : isTrackPage ? (
                    <div className={cx(bt.commonSize16, bt.fontWeight500)}>
                        {bookingStatusText ? (
                            <span style={{ color: bookingStatusColor }}><FormattedMessage {...messages[bookingStatusText]} /></span>
                        ) : (
                            <a href={`/tracking/${id}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    history.push({ pathname: `/tracking/${id}`, state: { from: history.location.pathname } });
                                }}
                                className={bt.viewAllLink}
                            >
                                <FormattedMessage {...messages.trackJob} />
                            </a>
                        )
                        }
                    </div>
                ) : null}
            </div>
        </div>
    )
}

export default injectIntl(withStyles(bt, s)(BookingIdCard))
